import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { Permission } from "__generated__/enums";

const AccountPermissionSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<Permission, Multiple>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			{...rest}
			fetchOptions={Object.values(Permission)}
			getOptionLabel={option => intl.formatMessage({ id: `USER_TYPE_${option}` })}
		/>
	);
};

export default AccountPermissionSelect;
